const DEFAULT_LANDING = {
  stores: {
    appStore: { url: '', enabled: true },
    googlePlay: { url: '', enabled: true },
  },
  social: {
    facebook: { url: '', enabled: true },
    instagram: { url: '', enabled: true },
    tiktok: { url: '', enabled: true },
  },
};

function mergeLink(entry) {
  return {
    enabled: entry?.enabled !== false,
    url: String(entry?.url || '').trim(),
  };
}

export function resolveLandingLinks(publicSettings) {
  const landing = publicSettings?.landing || DEFAULT_LANDING;

  return {
    appStore: mergeLink(landing.stores?.appStore),
    googlePlay: mergeLink(landing.stores?.googlePlay),
    facebook: mergeLink(landing.social?.facebook),
    instagram: mergeLink(landing.social?.instagram),
    tiktok: mergeLink(landing.social?.tiktok),
  };
}

export function hasVisibleStoreBadges(links) {
  return links.appStore.enabled || links.googlePlay.enabled;
}

export function hasVisibleSocialLinks(links) {
  return (
    (links.facebook.enabled && links.facebook.url) ||
    (links.instagram.enabled && links.instagram.url) ||
    (links.tiktok.enabled && links.tiktok.url)
  );
}
